import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useLanguage } from "@/context/LanguageContext";
import { useLegal } from "@/context/LegalContext";

const CookieConsent = () => {
  const { t } = useLanguage();
  const { open } = useLegal();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const choice = localStorage.getItem("ap_cookie_consent");
    if (!choice) {
      const timer = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(timer);
    }
  }, []);

  const decide = (value) => {
    localStorage.setItem("ap_cookie_consent", value);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="cookie-banner"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-4 inset-x-4 sm:left-auto sm:right-6 sm:bottom-6 sm:max-w-md z-[90] bg-[#0B1F33] text-white border border-white/10 shadow-2xl"
        >
          <div className="p-6">
            <p className="text-sm text-white/80 leading-relaxed">{t.cookie.message}</p>
            <div className="mt-5 flex flex-wrap items-center gap-3">
              <button
                data-testid="cookie-accept"
                onClick={() => decide("accepted")}
                className="bg-[#B87333] text-white text-[13px] font-semibold px-5 py-2.5 hover:bg-white hover:text-[#0B1F33] transition-colors duration-300"
              >
                {t.cookie.accept}
              </button>
              <button
                data-testid="cookie-reject"
                onClick={() => decide("necessary")}
                className="border border-white/30 text-white text-[13px] font-semibold px-5 py-2.5 hover:bg-white/10 transition-colors duration-300"
              >
                {t.cookie.reject}
              </button>
              <button
                data-testid="cookie-more"
                onClick={() => open("cookies")}
                className="text-[13px] font-medium text-[#B87333] underline underline-offset-4 hover:text-white transition-colors duration-300"
              >
                {t.cookie.more}
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieConsent;
